import { action, observable, makeObservable } from 'mobx';

class TurnstileStore {
  /**
   * @description
   * Solved Turnstile token. Single-use — Cloudflare rejects a token
   * that has already been verified, so it must be cleared after every
   * submit attempt, successful or not.
   */
  @observable
  token: string | null = null;

  /**
   * @description
   * Cloudflare could not be reached or the widget failed to render.
   * Registration must stay possible in that case — the API still verifies,
   * so a missing token becomes a normal validation error rather than a
   * permanently disabled submit button.
   */
  @observable
  isUnavailable: boolean = false;

  /**
   * @description
   * Widget id returned by turnstile.render, needed to reset/remove the widget
   */
  widgetId: string | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  setToken(token: string) {
    this.token = token;
    this.isUnavailable = false;
  }

  @action
  markUnavailable() {
    this.token = null;
    this.isUnavailable = true;
  }

  @action
  clear() {
    this.token = null;
  }

  setWidgetId(widgetId: string | null) {
    this.widgetId = widgetId;
  }

  /**
   * @description
   * Clear the solved token and ask Cloudflare for a fresh challenge
   */
  @action
  reset() {
    this.token = null;
    this.isUnavailable = false;

    if (this.widgetId && window.turnstile) {
      try {
        window.turnstile.reset(this.widgetId);
      } catch (error) {
        console.error('Could not reset Turnstile widget:', error);
      }
    }
  }
}

export { TurnstileStore };
